import { h, Fragment } from 'preact';
import { useMemo } from 'preact/hooks';

const OptionValue = ({
  value,
  isQuickView,
  selectedOption,
  optionId,
  productId,
  handleVariantChange,
  currentVariant,
  option,
  product,
  isGiftCard,
}) => {
  const variant = useMemo(() => {
    const options = Object.fromEntries(
      currentVariant.selectedOptions.map((item) => {
        if (item.name === option.name) {
          return [
            item.name,
            {
              ...item,
              value,
            },
          ];
        }
        return [item.name, item];
      }),
    );

    return product.variants.find((v) =>
      v.selectedOptions.every(
        (item) => item.value === options[item.name].value,
      ),
    );
  }, [currentVariant]);

  return (
    variant &&
    <label
      htmlFor={`${isQuickView ? 'qw' : ''}${productId}-${value.replace(
        ' ',
        '',
      )}`}
      key={`${optionId}-${value}`}
      className={`
        ${isQuickView ? 'mr-1' : 'mr-2'} 
        ${isGiftCard ? 'md:w-auto' : ''} 
        flex items-center mb-1
      `}
    >
      {option.values.length > 1 && (
        <>
          <input
            type="radio"
            id={`${isQuickView ? 'qw' : ''}${productId}-${value.replace(
              ' ',
              '',
            )}`}
            name={`${productId}-${option.name}`}
            value={value}
            checked={selectedOption?.value === value}
            onChange={handleVariantChange}
            data-option-name={option.name}
            className="peer absolute opacity-0 cursor-pointer m-0 p-0 h-0 w-0"
          />
          <span
            className={`${!variant?.availableForSale &&
              'before:block before:content-[""] before:w-0.75 before:h-40 before:top-[1.5px] before:-left-[1.8px] before:bg-grey-B4 before:absolute before:border before:border-white before:-rotate-[68.2deg] before:origin-top-left '
              // eslint-disable-next-line max-len
              }  overflow-hidden body-xs peer-checked:text-supergoop-blue peer-checked:border-supergoop-blue ${isQuickView
                ? 'py-3 px-4 block text-grey-5C'
                : 'h-[34px] w-full min-w-[80px] flex justify-center items-center text-grey-2A px-2 md:px-3 md:min-w-[80px]'
              } relative cursor-pointer border border-grey-B4`}
          >
            {value}
          </span>
        </>
      )}
    </label>
  );
};
const SizeSelector = ({
  option,
  optionId,
  productId,
  handleVariantChange,
  selectedOption,
  isQuickView,
  currentVariant,
  product,
  isGiftCard,
}) => {
  const sortedOptions = option.values.sort((a, b) => {
    const aPrice = a[0] === '$' ? parseFloat(a.slice(1, -1)) : 0;
    const bPrice = b[0] === '$' ? parseFloat(b.slice(1, -1)) : 0;
    return aPrice - bPrice;
  });

  return (
    <div className={`${!isQuickView ? 'mb-5' : ''}`}>
      {product.variants.length >= 1 && !isQuickView && (
        <label htmlFor={optionId} className="block body-xs text-grey-5C mb-1">
          <span className="uppercase label-12 tracking-[2px] text-grey-2A">
            {option.name}
          </span>
          <span className="inline-block ml-2.5 body-xs text-grey-5C">
            {selectedOption?.value}
          </span>
        </label>
      )}
      <div className={`${isQuickView && 'flex flex-wrap mt-2 mb-1'}`}>
        <div className={`flex flex-1 flex-wrap`}>
          {sortedOptions.map((value, index) => (
            <OptionValue
              selectedOption={selectedOption}
              value={value}
              optionId={optionId}
              productId={productId}
              handleVariantChange={handleVariantChange}
              isQuickView={isQuickView}
              key={index}
              currentVariant={currentVariant}
              option={option}
              product={product}
              isGiftCard={isGiftCard}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
export default SizeSelector;
